export default __webpack_public_path__ + "static/media/ic-calendar.e3e93449.svg";